import type { ISerialize } from '@/objects/ISerialize';

export class DeviceAntenna implements ISerialize {
    public Connected: boolean;

    public IsInternal: boolean;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Connected?: boolean; IsInternal?: boolean }) {
        this.Connected = values.Connected ?? false;

        this.IsInternal = values.IsInternal ?? false;
    }

    public serialize(): string {
        return '{' + `"Connected": ${JSON.stringify(this.Connected)}` + ',' + `"IsInternal": ${JSON.stringify(this.IsInternal)}` + '}';
    }

    /**
     * Creates an instance of DeviceAntenna from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Connected?: boolean; IsInternal?: boolean }): DeviceAntenna {
        return new DeviceAntenna(values);
    }

    public static _FromServerJson(json: any): DeviceAntenna {
        return new DeviceAntenna({ Connected: json.Connected, IsInternal: json.IsInternal });
    }

    /**
     * Creates an instance of DeviceAntenna from another instance of DeviceAntenna.
     * @param other The DeviceAntenna you want to clone
     * @returns A cloned DeviceAntenna
     */
    public static FromOther(other: DeviceAntenna): DeviceAntenna {
        return DeviceAntenna._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceAntenna.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceAntenna';
}
